<template>
  <div class>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>用户名</label>
          <input
            clearable
            v-model="search.userName"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
          </span>
          <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
          <span class="add_btn">
            <button @click="addrOrEdit()" type="button" class="btn btn-default" id="addarea">添加</button>
          </span>
          <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        height="100%"
        :data="tableListData"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column show-overflow-tooltip label="登录名" prop="username"></el-table-column>
        <el-table-column show-overflow-tooltip label="用户名" prop="name"></el-table-column>
        <el-table-column show-overflow-tooltip label="手机号" prop="mobilePhone"></el-table-column>
        <el-table-column show-overflow-tooltip label="作用域">
          <template slot-scope="scope">
            <span>{{scope.row.scopeId&&JSON.parse(scope.row.scopeId)?JSON.parse(scope.row.scopeId).name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="角色">
          <template slot-scope="scope1">
            {{scope1.row.attr2&&JSON.parse(scope1.row.attr2).length>0?JSON.parse(scope1.row.attr2)[0].name:''}}
            <!--<el-dropdown>
						<span class="el-dropdown-link">
						{{scope.row.attr2?JSON.parse(scope.row.attr2)[0].name:''}}<i v-show='scope.row.attr2?JSON.parse(scope.row.attr2).length>1:0' class="el-icon-arrow-down el-icon--right"></i>
						</span>
						 <el-dropdown-menu slot="dropdown" v-show='scope.row.attr2?JSON.parse(scope.row.attr2).length>1:false'>
							<el-dropdown-item v-for='item in scope.row.attr2?JSON.parse(scope.row.attr2):[]' :key='item.id'>{{item.name}}</el-dropdown-item>
						</el-dropdown-menu>
            </el-dropdown>-->
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="150px">
          <template slot-scope="scope">
            <button class="edit operate-button" type="button" @click="addrOrEdit(scope.row.id)">修改</button>
            <button class="delete operate-button" @click="del(scope.row.id)" type="button">删除</button>
            <button class="delete operate-button" @click="resetPassword(scope.row.id)">重置密码</button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!-- 添加或编辑 -->
    <el-dialog
      title="添加/编辑账号"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
      :lock-scroll="false"
    >
      <el-form
        ref="form"
        label-position="right"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
        id="form"
      >
        <el-form-item label="登录名" prop="username">
          <el-col :span="18">
            <el-input
              v-if="form.id"
              readonly
              clearable
              v-model.trim="form.username"
              auto-complete="off"
              v-noBlankSpace
            ></el-input>
            <el-input v-if="!(form.id)" clearable v-model.trim="form.username" auto-complete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item v-if="!(form.id)" label="密码" prop="password">
          <el-col :span="18">
            <el-input clearable v-model="form.password" auto-complete="off" type="password"></el-input>
            <span class="promptText">默认密码0123456</span>
          </el-col>
        </el-form-item>
        <el-form-item label="用户名" prop="name">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.name" auto-complete="off" v-noBlankSpace></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="手机号">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.mobilePhone" auto-complete="off" v-noBlankSpace></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="角色" prop="groups">
          <el-select v-model="form.groups" clearable>
            <el-option v-for="item in allGroups" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <!-- <el-checkbox-group v-model="form.groupCheckList">
						<el-checkbox   v-for="item in allGroups" :key='item.id' label='item.id'>{{item.name}}</el-checkbox>
						
          </el-checkbox-group>-->
        </el-form-item>
        <el-form-item label="作用域" prop="scopeName">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.scopeName"></el-input>
            <el-tree
              :default-expand-all="true"
              :data="allScopes"
              :props="defaultProps"
              @node-click="handleScopeNodeClick"
            ></el-tree>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrOrEditTrue()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";

import { mapState, mapMutations, mapGetters } from "vuex";

import {
  delAccount,
  editUser,
  getScopeTree,
  resetPassword,
  getUserSingleScope,
  getUserSingleGroup,
  getScopeList,
  getGroupList,
  getUserList,
  addUser,
  getManagerList,
  getAllRole,
  addManager,
  getManagerSingle,
  delRole,
} from "@/api/url";

import Page from "../../commons/page.vue";

import Refresh from "../../commons/refresh.vue";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      manager_btn_edit: false,
      manager_btn_delete: false,
      isShowScopeTree: false,
      search: {
        pageNumber: 1,
        pageSize: 12,
        userName: "",
      },
      defaultProps: {
        label: "name",
        children: "children",
      },
      tableListData: null,
      formLabelWidth: "100px",
      dialogFormVisible: false,
      allScopes: [],
      allGroups: [],
      form: {
        id: "",
        name: "",
        username: "",
        password: "",
        mobilePhone: "",
        groups: "",
        // groupCheckList:[],
        scopeName: "",
        scopeId: "",
      },
      rules: {
        username: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                if (/^\w{2,12}$/.test(value) == false) {
                  callback(new Error("请填写2到12位数字字母或下划线"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写账号"));
              }
            },
          },
        ],
        password: [
          {
            required: false,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (!rule.required) return callback();
              if (value != "") {
                if (/^\w{2,12}$/.test(value) == false) {
                  callback(new Error("请填写2到12位数字字母或下划线"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写密码"));
              }
            },
          },
        ],
        attr1: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                if (
                  /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("请填写正确手机号"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写手机号"));
              }
            },
          },
        ],
        groups: [
          {
            required: true,
            message: "请选择角色",
            trigger: ["blur", "change"],
          },
        ],
        scopeName: [
          {
            required: true,
            message: "请选择作用域",
            trigger: ["blur", "change"],
          },
        ],
        name: [{ required: true, message: "请填写用户", trigger: "blur" }],
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage, open) {
      var _this = this;
      this.$get(getUserList(), {
        username: this.search.userName,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);

        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
        // console.log(_this.tableListData)
      });
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.userName = "";
    },
    getAllScopes: function () {
      this.$get(getScopeTree()).then((data) => {
        this.allScopes = data;
      });
    },
    getAllGroups: function () {
      this.$get(getGroupList(), {}).then((data) => {
        this.allGroups = data;
        // console.log("this.allGroups")
        // console.log(this.allGroups)
      });
    },

    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    addrOrEdit: function (id) {
      var _this = this;
      this.dialogFormVisible = true;

      if (Boolean(id)) {
        this.rules.password[0].required = false;
        this.form.id = id;
        this.$get(getUserList(), { id: id }).then((data) => {
          if (data.status != 200) return;
          // this.form.id=data.data.id;
          var tempData = data.data.rows[0];
          this.form.name = tempData.name;
          this.form.username = tempData.username;
          this.form.mobilePhone = tempData.mobilePhone;
          this.form.scopeId = tempData.scopeId
            ? JSON.parse(tempData.scopeId).id
            : "";
          this.form.scopeName = tempData.scopeId
            ? JSON.parse(tempData.scopeId).name
            : "";
          this.form.groups =
            JSON.parse(tempData.attr2).length > 0
              ? JSON.parse(tempData.attr2)[0].id
              : "";
          // console.log('this.form.groups')
          // console.log(this.form.groups)
        });
      } else {
        this.rules.password[0].required = true;
        this.form.id = "";
        this.form.name = "";
        this.form.username = "";
        this.form.mobilePhone = "";
        this.form.password = "0123456";
        this.form.scopeId = "";
        this.form.groups = "";
        return;
      }
    },

    addrOrEditTrue: function () {
      var _this = this;
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          _this.isShowScopeTree = false;

          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(addUser(), {
                name: _this.form.name,
                username: _this.form.username,
                password: _this.form.password,
                mobilePhone: _this.form.mobilePhone,
                departId: _this.form.scopeId,
                groupId: _this.form.groups,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    title: "失败",
                    message: data.message,
                    type: "warning",
                  });

                  return;
                }
                _this.$notify({
                  title: "成功",
                  message: "添加成功",
                  type: "success",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$postRequest(editUser(), {
                id: _this.form.id,
                name: _this.form.name,
                username: _this.form.username,
                password: _this.form.password,
                mobilePhone: _this.form.mobilePhone,
                departId: _this.form.scopeId,
                groupId: _this.form.groups,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    title: "失败",
                    message: data.message,
                    type: "warning",
                  });
                  return;
                }
                _this.$notify({
                  title: "成功",
                  message: "修改成功",
                  type: "success",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该管理员？",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(delAccount() + "?userId=" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
            });
            _this.tableList(_this.pageObj.curIndex);
          });
        }
      );
    },
    resetPassword(username) {
      this.$postRequest(resetPassword() + "?username=" + username, {
        //username
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          title: "成功",
          message: "重置密码成功,默认密码是0123456",
          type: "success",
        });
      });
    },
    // showScopeTree(){
    // 	this.isShowScopeTree=true;
    // },
    handleScopeNodeClick(obj, node, data) {
      this.form.scopeName = obj.name;
      this.form.scopeId = obj.id;
      if (obj.userId) {
        this.$notify({
          title: "温馨提示",
          message: `${obj.name}已被其他用户绑定！`,
          type: "warn",
        });
        return;
      }
      // this.isShowScopeTree=false;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.manager_btn_edit = this.elements["manager:btn_edit"];
      this.manager_btn_delete = this.elements["manager:btn_delete"];
    },
  },
  components: {
    Page,
    Refresh,
  },
  created: function () {
    this.permiss;
   
    this.getAllScopes();
    this.getAllGroups();
  },
  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
</style>